import styled from 'styled-components'

import { bowtieTheme } from 'plugin-codaf-risk-ext-bowtie/utils/constants'

interface StyleProps {
    fieldSize?: number
    first?: boolean
    color?: string
}

export const GraphicContainer = styled.div`
    width: 100%;
    height: 288px;
    background-color: ${({ theme }) => theme['gray-0']};

    .title {
        width: 100%;
        height: 40px;
        background: ${({ theme }) => theme['gray-100']};
        border-top: 1px solid;
        border-color: ${({ theme }) => theme['gray-200']};
        display: flex;
        align-items: center;
        padding: 0 16px;

        span {
            font-size: 15px;
            font-weight: 700;
            color: ${({ theme }) => theme['gray-800']};
        }
    }

    .GraphContainerNoInfo {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .GraphContainer {
        width: 100%;
        overflow: auto;
        .description {
            padding: 20px 16px;

            span {
                font-size: 12px;
            }
        }
    }

    .timelineGraph {
        width: 100%;
        display: flex;
        flex-direction: row;
        padding: 0px 32px;
        background: transparent;
        margin-top: 20px;
        /* position: absolute; */

        .GraphField {
            text-transform: uppercase;
            padding-left: 3px;
            line-height: 14px;
        }

        .GraphField:hover {
            display: hidden;
        }

        /* .GraphField + .GraphField {
            border-left: 1px dotted black;
        } */
    }

    .graph {
        width: 100%;
        display: flex;
        flex-direction: row;
        padding: 0px 32px;

        .UNKNOWN {
            background: #606a80;
        }

        .UNKNOWN {
            background: ${({ theme }) => theme['gray-700']};
        }

        .Unacceptable {
            background: ${bowtieTheme.topEvent.colorStatus.intolerable};
        }

        .Inaceitável {
            background: ${bowtieTheme.topEvent.colorStatus.intolerable};
        }

        .Tolerable {
            background: ${bowtieTheme.topEvent.colorStatus.tolerable};
        }

        .Tolerável {
            background: ${bowtieTheme.topEvent.colorStatus.tolerable};
        }

        .Acceptable {
            background: ${bowtieTheme.topEvent.colorStatus.accetable};
        }

        .Aceitável {
            background: ${bowtieTheme.topEvent.colorStatus.accetable};
        }

        .Event {
            background: ${bowtieTheme.topEvent.colorStatus.unknown};
        }

        .Evento {
            background: ${bowtieTheme.topEvent.colorStatus.unknown};
        }
    }
`

export const GraphicField = styled.div<StyleProps>`
    width: ${props => (props.fieldSize < 0.2 ? '0.2%' : `${props.fieldSize}%`)};
    height: 80px;
    background: ${props => props.color};

    &.ACTIVE {
        background: #129a96;
    }

    &.INACTIVE {
        background: ${({ theme }) => theme['red-700']};
    }
`

// inserir apenas uma linha em absoluto

export const Timeline = styled.div<StyleProps>`
    width: ${props => (props.fieldSize < 0.2 ? '0.2%' : `${props.fieldSize}%`)};
    height: 30px;

    .absoluteLine {
        border-left: ${props => !props.first && '1px dotted black'};
        border-color: ${({ theme }) => theme['gray-700']};
        position: absolute;
        height: 120px;
    }

    span {
        margin-left: 3px;
    }
`

export const Line = styled.div`
    width: calc(100% - 48px);
    height: 2px;
    background: ${({ theme }) => theme['gray-700']};
    margin: 0px 24px;
`

export const GraphicPopover = styled.div`
    /* margin-top: -40px; */
    .timeInfoPopover {
        display: flex;
        flex-direction: column;
    }
    .timePopover {
        margin-top: 5px;
        display: flex;
        flex-direction: row;
        text-transform: capitalize;
        align-items: center;
        .iconStatus {
            width: 10px;
            height: 10px;
            margin-right: 6px;
            background: #606a80;
            &.ACTIVE {
                background: #129a96;
            }
            &.INACTIVE {
                background: #c43535;
            }
        }

        .DEGRADED {
            background: #f89300;
        }

        .LOW_DEGRADED {
            background: #a2a94f;
        }

        .HIGH_DEGRADED {
            background: #f89300;
        }

        .UNKNOWN {
            background: #606a80;
        }

        .Unacceptable {
            background: ${bowtieTheme.topEvent.colorStatus.intolerable};
        }

        .Inaceitável {
            background: ${bowtieTheme.topEvent.colorStatus.intolerable};
        }

        .Tolerable {
            background: ${bowtieTheme.topEvent.colorStatus.tolerable};
        }

        .Tolerável {
            background: ${bowtieTheme.topEvent.colorStatus.tolerable};
        }

        .Acceptable {
            background: ${bowtieTheme.topEvent.colorStatus.accetable};
        }

        .Aceitável {
            background: ${bowtieTheme.topEvent.colorStatus.accetable};
        }

        .Event {
            background: ${bowtieTheme.topEvent.colorStatus.unknown};
        }

        .Evento {
            background: ${bowtieTheme.topEvent.colorStatus.unknown};
        }
    }
`
